import React, { useEffect, memo, useCallback, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { setIframeVisible } from '../actions/layout';
import { logging } from '../actions/log';
import styles from './Iframe.module.less';
import { cacheKeys } from '../constants/storageKeys';
import { logNative } from '../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectIframeInfo = createSelector(
  state => state.layout,
  layout => layout.iframeInfo,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const iframeInfo = useSelector(selectIframeInfo); // 展示iframe
  const userInfo = useSelector(selectUserInfo);

  const iframeRef = useRef(null);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false); // 评论内容

  useEffect(() => {
    // 快捷方式弹窗 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Shop_Mall',
        label: '',
        param2: {
          source: iframeInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          url: iframeInfo.url,
          id: iframeInfo && iframeInfo.data && iframeInfo.data.id ? iframeInfo.data.id : 'unknown',
        },
      }),
    );
  }, []);

  /**
   * 推送登录信息, 退出登录，登录了都post登录了的用户信息
   */
  useEffect(() => {
    // 获取用户是否登录
    // const login_status = window.CallNativeMethod('get_login_status');
    if (
      iframeRef.current &&
      iframeRef.current.contentWindow &&
      isIframeLoaded
      // &&
      // login_status === '1' &&
      // userInfo.st
    ) {
      postLoginInfo();
    }
  }, [iframeRef, userInfo, isIframeLoaded]);

  const postLoginInfo = useCallback(() => {
    if (iframeRef && iframeRef.current && iframeRef.current.contentWindow) {
      const login_status = window.CallNativeMethod('get_login_status');
      const userToken = localStorage.getItem(cacheKeys.X_LESYNC_TOKEN);
      const data = {
        acceptAddress: 'PCShop',
        sourceAddress: 'PCStore',
        type: 'loginInfo',
        data: {
          useInfo: {},
        },
      };
      if (login_status === '1') {
        const useInfoStr = localStorage.getItem(cacheKeys.USER_INFO) || '{}';
        const useInfoObj = { ...JSON.parse(useInfoStr), 'X-Lesync-Token': userToken };
        data.data.useInfo = useInfoObj;
      }

      setTimeout(() => {
        logNative('商店postMessage to iframe', data);
        iframeRef.current.contentWindow.postMessage(JSON.stringify(data), '*');
      }, 300);
    }
  }, [iframeRef]);

  /**
   * 注册接受消息
   */
  useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      window.addEventListener('message', receptIframeMessage, true);
    }
  }, [iframeRef]);

  /**
   * 接受的消息处理
   */
  const receptIframeMessage = useCallback(
    e => {
      try {
        const receptDate = JSON.parse(e && e.data);
        if (receptDate.acceptAddress === 'PCStore' && receptDate.sourceAddress === 'PCShop') {
          logNative('商店接收Message from iframe', receptDate);
          // 处理关闭商城框通知
          if (receptDate.type === 'closeShop') {
            // 关闭商城框
            dispatch(
              logging({
                category: 'C',
                action: 'Shop_Mall_Close',
                label: '',
                param2: {
                  source: iframeInfo.source,
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                  url: iframeInfo.url,
                  id:
                    iframeInfo && iframeInfo.data && iframeInfo.data.id
                      ? iframeInfo.data.id
                      : 'unknown',
                },
              }),
            );
            window.removeEventListener('message', receptIframeMessage, true);
            dispatch(
              setIframeVisible({
                visible: false,
              }),
            );
          }
          if (receptDate.type === 'getLoginInfo') {
            // 获取用户是否登录
            const login_status = window.CallNativeMethod('get_login_status');
            if (login_status === '1') {
              postLoginInfo();
            } else {
              // 弹出登录
              dispatch(
                logging({
                  category: 'C',
                  action: 'Shop_Mall_Login',
                  label: '',
                  param2: {
                    source: iframeInfo.source,
                    source_p: logInfoData.source_p,
                    source_pp: logInfoData.source_pp,
                    url: iframeInfo.url,
                    id:
                      iframeInfo && iframeInfo.data && iframeInfo.data.id
                        ? iframeInfo.data.id
                        : 'unknown',
                  },
                }),
              );
              window.CallNativeMethod('login');
            }
          }
        }
      } catch (error) {
        logNative('iframe接受的消息处理 错误', error);
      }
    },
    [iframeRef],
  );

  const iframeOnLoad = useCallback(e => {
    setIsIframeLoaded(true);
  }, []);

  const handleClose = useCallback(() => {
    // 关闭商城框
    dispatch(
      logging({
        category: 'C',
        action: 'Shop_Mall_Close',
        label: '',
        param2: {
          source: iframeInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          url: iframeInfo.url,
          id: iframeInfo && iframeInfo.data && iframeInfo.data.id ? iframeInfo.data.id : 'unknown',
        },
      }),
    );
    dispatch(
      setIframeVisible({
        visible: false,
      }),
    );
  }, [dispatch, logInfoData, iframeInfo]);

  return (
    <div className={styles.iframe_bg}>
      <div className={styles.iframe_close_dialog} onClick={handleClose} />
      <div className={styles.iframe}>
        {/* <div className="iframe_close" onClick={handleClose}></div> */}
        {/* <div className="iframe_close_dialog" onClick={handleClose} /> */}
        <iframe
          onLoad={iframeOnLoad}
          ref={iframeRef}
          src={`${iframeInfo.url}`}
          style={{ width: '720px', height: '500px', border: 'none' }}
        />
      </div>
    </div>
  );
});
